import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button, Spin, theme } from 'antd';
import { useDispatch } from 'react-redux';
import { actions } from 'redux/userView/slice';
import { Formik } from 'formik';
import { Form } from 'formik-antd';
import InputField from 'components/Forms/input';
import UploadField from 'components/Forms/upload';
import SelectField from 'components/Forms/select';
import useStyles from 'components/Forms/styles';
import ChangePassword from 'components/changePassword';
import Card from 'components/card';
import roleFieldCols from './roleFieldCols';

const User = ({
  loaded,
  avatar,
  validationSchema,
  onSubmit,
  currentCity,
  cities,
  roles,
  currentMarketplace,
  marketplaces,
  currentPaqueryPoint,
  paqueryPoints,
  currentStore,
  stores,
  selectMarketplace,
  selectUserRoleId,
  setCurrentCountry,
  initialValues,
  countries,
  isProfile,
  isUserModify,
  isAdd,
  disabledInputs,
}) => {
  const dispatch = useDispatch();
  const { token } = theme.useToken();
  const classes = useStyles({ theme: token });
  const formik = useRef();
  const optionGenerator = (arrayData) =>
    arrayData.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  useEffect(() => {
    formik.current.setFieldValue('cityID', currentCity);
  }, [currentCity]);
  useEffect(() => {
    formik.current.setFieldValue('marketplaceID', currentMarketplace);
  }, [currentMarketplace]);
  useEffect(() => {
    formik.current.setFieldValue('paqueryPointID', currentPaqueryPoint);
  }, [currentPaqueryPoint]);
  useEffect(() => {
    formik.current.setFieldValue('storeID', currentStore);
  }, [currentStore, currentMarketplace]);
  const statusList = [
    { name: 'Activo', id: 1 },
    { name: 'Dado de baja', id: 6 },
  ];
  const optionStores = stores.map((store) => ({
    label: `Código ${store.storeCode} - ${store.name}`,
    value: store.id,
  }));
  const optionsCountries = optionGenerator(countries);
  const optionsCities = optionGenerator(cities);
  const optionsStatus = optionGenerator(statusList);
  const optionsMarketplace = optionGenerator(marketplaces);
  const optionsPaqueryPoints = optionGenerator(paqueryPoints);
  const optionsRoles = roles?.map((role) => ({
    label: role.name,
    value: role.value,
  }));
  const handleImageChange = (image) => dispatch(actions.setAvatar(image));
  return (
    <Spin spinning={!loaded}>
      <Formik
        enableReinitialize
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={onSubmit}
        innerRef={formik}
      >
        {({ values }) => (
          <Form>
            <Row type="flex" justify="space-between">
              <Col xs={24} md={16}>
                <Card
                  title="Información básica"
                  style={{ margin: '8px', height: '96.5%' }}
                >
                  <Col span={24} className={classes.cardContent}>
                    <Row>
                      <Col xs={24} lg={8}>
                        <UploadField
                          image={avatar}
                          onChangeImage={handleImageChange}
                        />
                      </Col>
                      <Col xs={24} lg={16}>
                        <Row gutter={[16, 8]}>
                          <Col span={24}>
                            <InputField label="ID" fieldName="id" disabled />
                          </Col>
                          <Col xs={24} md={12}>
                            <InputField label="Nombre" fieldName="name" />
                          </Col>
                          <Col xs={24} md={12}>
                            <InputField label="Apellido" fieldName="lastName" />
                          </Col>
                          <Col span={24}>
                            <SelectField
                              label="Rol"
                              onChange={(role) => selectUserRoleId(role)}
                              fieldName="userRoleID"
                              disabled={disabledInputs.userRoleID}
                              options={optionsRoles}
                            />
                          </Col>
                          <Col xs={roleFieldCols(values.userRoleID).marketplace}>
                            <SelectField
                              label="Marketplace"
                              fieldName="marketplaceID"
                              onChange={(marketplace) =>
                                selectMarketplace(marketplace)
                              }
                              options={optionsMarketplace}
                            />
                          </Col>
                          <Col
                            xs={roleFieldCols(values.userRoleID).paqueryPoint}
                          >
                            <SelectField
                              label="Paquery Point"
                              fieldName="paqueryPointID"
                              options={optionsPaqueryPoints}
                            />
                          </Col>
                          <Col xs={roleFieldCols(values.userRoleID).store}>
                            <SelectField
                              label="Tienda"
                              fieldName="storeID"
                              disabled={disabledInputs.store}
                              options={optionStores}
                            />
                          </Col>
                          {(isProfile || isUserModify) && (
                            <Col span={24}>
                              <ChangePassword email={values.email} />
                            </Col>
                          )}
                          {isUserModify && (
                            <Col span={24}>
                              <SelectField
                                label="Estado"
                                fieldName="statusID"
                                options={optionsStatus}
                              />
                            </Col>
                          )}
                          {isAdd && (
                            <>
                              <Col span={12}>
                                <InputField
                                  label="Contraseña"
                                  type="password"
                                  fieldName="pwd"
                                />
                              </Col>
                              <Col span={12}>
                                <InputField
                                  label="Confirmar contraseña"
                                  type="password"
                                  fieldName="confirmpwd"
                                />
                              </Col>
                            </>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Card>
              </Col>
              <Col xs={24} md={8}>
                <Card title="Información de contacto" style={{ margin: '8px' }}>
                  <Row>
                    <Col span={24} className={classes.cardContent}>
                      <Row gutter={[8, 8]}>
                        <Col xs={24}>
                          <InputField
                            label="Móvil"
                            fieldName="phone"
                            type="number"
                          />
                        </Col>
                        <Col xs={24}>
                          <InputField
                            label="Email"
                            fieldName="email"
                            disabled={disabledInputs.email}
                          />
                        </Col>
                        <Col xs={24}>
                          <SelectField
                            label="País"
                            fieldName="countryID"
                            onChange={(country) => setCurrentCountry(country)}
                            options={optionsCountries}
                          />
                        </Col>
                        <Col xs={24}>
                          <SelectField
                            label="Ciudad"
                            fieldName="cityID"
                            options={optionsCities}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24} style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  className={classes.saveButton}
                  size="large"
                >
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Spin>
  );
};

User.propTypes = {
  loaded: PropTypes.bool.isRequired,
  avatar: PropTypes.shape({
    name: PropTypes.string,
    data: PropTypes.string,
  }).isRequired,
  countries: PropTypes.arrayOf(PropTypes.object).isRequired,
  validationSchema: PropTypes.shape({}).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isProfile: PropTypes.bool,
  isUserModify: PropTypes.bool,
  isAdd: PropTypes.bool,
  roles: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentCity: PropTypes.number,
  cities: PropTypes.arrayOf(PropTypes.object),
  setCurrentCountry: PropTypes.func,
  currentMarketplace: PropTypes.number,
  marketplaces: PropTypes.arrayOf(PropTypes.object),
  selectMarketplace: PropTypes.func,
  selectUserRoleId: PropTypes.func,
  currentPaqueryPoint: PropTypes.number,
  paqueryPoints: PropTypes.arrayOf(PropTypes.object),
  currentStore: PropTypes.number,
  stores: PropTypes.arrayOf(PropTypes.object),
  initialValues: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    lastname: PropTypes.string,
    pwd: PropTypes.string,
    phone: PropTypes.number,
    confirmpwd: PropTypes.string,
    cityID: PropTypes.number,
    countryID: PropTypes.number,
    userRoleID: PropTypes.number,
    marketplaceID: PropTypes.number,
    paqueryPointID: PropTypes.number,
    storeID: PropTypes.number,
    email: PropTypes.string,
  }),
  disabledInputs: PropTypes.shape({
    userRoleID: PropTypes.bool,
    email: PropTypes.bool,
    store: PropTypes.bool,
  }),
};

User.defaultProps = {
  isProfile: false,
  isUserModify: false,
  isAdd: false,
  marketplaces: [],
  paqueryPoints: [],
  stores: [],
  // ponytail: no-op y no null — `userProfile` no los pasa (su select de rol está disabled).
  selectMarketplace: () => {},
  selectUserRoleId: () => {},
  currentMarketplace: null,
  currentPaqueryPoint: null,
  currentStore: null,
  currentCity: 1,
  cities: [],
  setCurrentCountry: 1,
  initialValues: {
    id: null,
    name: '',
    lastname: '',
    pwd: '',
    confirmpwd: '',
    phone: null,
    confirmpassword: '',
    cityID: null,
    countryID: 1,
    marketplaceID: null,
    paqueryPointID: null,
    storeID: null,
    email: '',
  },
  disabledInputs: {
    userRoleID: false,
    email: false,
    store: true,
  },
};

export default User;
